import React, { useContext, useState } from "react";
import Vehicle from "../components/Vehicle";
import AppContext from "../context";
import swal from "sweetalert2";
import axios from "axios";
import ContactInformationCheck from "../components/ContactInformationCheck";
import { useTranslation } from "react-i18next";

export default function RecallModal({ a, k }) {
	const { setModal } = useContext(AppContext);
	const [ajax, setAjax] = useState(false);
	const v = a.vehicles[k];
	const { i18n } = useTranslation();

	const getVehicleName = () => {
		if (k !== undefined && a.vehicles && a.vehicles[k]) {
			return (
				(a.vehicles[k].vehicle_maker ? a.vehicles[k].vehicle_maker : "") +
				(a.vehicles[k].vehicle_model_year
					? " " + a.vehicles[k].vehicle_model_year
					: "")
			);
		}
		// return "Unknown vehicle";
	};

	const getVin = () => {
		if (k !== undefined && a.vehicles && a.vehicles[k]) {
			return a.vehicles[k].vin_code;
		}
		// return "";
	};

	const getZip = () => {
		if (k !== undefined && a.vehicles && a.vehicles[k]) {
			return a.vehicles[k].owner_zip;
		}
		// return "";
	};

	const submit = (data) => {
		setAjax(true);

		gtag("event", "page_view", {
			page_title: "Success",
			page_location: window.location.href,
			page_path: "/vehicle/success"
		});

		const headers = {
			'page-referrers': window.location.href
		}

		axios
			.post("/leads/create", {
				firstName: data.name.split(" ")[0],
				lastName: data.name.split(" ")[1],
				phone: data.phone,
				email: data.email,
				accidentId: a.custom_id,
				legal_consult: true,
				fault: false,
				injured:
					a.vehicles[k].participants[0] &&
					a.vehicles[k].participants[0].injury !== "NOT INJURED"
						? true
						: false,
				source: "recall",
				occupant: getVehicleName(),
				vin: getVin(),
				zip: getZip(),
				state: a.state,
				language: i18n.language,
				trusted_form_cert: window.cert?.xxTrustedFormCertUrl || "",
				gclidcrm: window.gclidcrm || "",
			}, { headers })
			.then((d) => {
				if (d.data.success) {
					gtag("event", "car-success", {
						event_category: "car",
						event_label: "car-success-hot"
					});

					swal.fire(
						"Thank You!",
						`Thank you for requesting a free legal consultation, you will be contacted by our team shortly.`,
						"success"
					);
					setModal("");
				} else {
					swal.fire(
						"Error",
						"Some error ocurred while creating your request.",
						"error"
					);
				}
			})
			.catch((e) => {
				if (e.response.data.error === "blacklisted") {
					swal
						.fire(
							"Error",
							"You are commercial user, please sign up for business service!",
							"warning"
						)
						.then(() => {
							window.location.href = "https://business.myaccident.org";
						});
				} else {
					swal.fire(
						"Error",
						"Some error ocurred while creating your request.",
						"error"
					);
				}
			});
	};
	return (
		<div id="car-lead" className={ajax ? "ajax" : ""}>
			<a className="close" onClick={() => setModal("")}>
				<img src="/assets/icon-close.png" alt="close" />
			</a>
			<div className="content">
				<h1>Were you an occupant of this vehicle that was injured?</h1>
				<div
					className="row"
					style={{
						maxWidth: 800,
						margin: "40px auto",
						alignItems: "flex-start"
					}}
				>
					<div>
						<h3>
							{v.vehicle_maker} {v.vehicle_model_year}
						</h3>
						<Vehicle v={v} alt />
					</div>
					<div>
						<div style={{ textAlign: "center", margin: 10 }}>
							<img src="/assets/nhtsa.png" height="43" />
							<img
								src="/assets/product-recall.jpg"
								height="43"
								style={{ marginLeft: 10 }}
							/>
						</div>
						NHTSA records indicate that this vehicle has been involved in a
						manufacture recall that could have contributed to the severity of
						your accident. You may be entitled to compensation.
						<br />
						<br />
						<h2>Request A Free Case Evaluation</h2>
						<br />
						<ContactInformationCheck
							next={(data) => {
								submit(data);
							}}
							back={() => setModal("")}
							hideTitle={true}
							smsSent={() => {}}
						/>
					</div>
				</div>
				<div
					style={{
						maxWidth: 800,
						margin: "40px auto"
					}}
				>
					By submitting this request, you agree that MyAccident.org can share
					this information with one of its sponsors so they can call/text you
					about your inquiry. You don't need to consent as condition of agreeing
					to hire a lawyer. You also agree to our{" "}
					<a href="https://myaccident.org/terms-of-use" target="_blank">
						Terms of Use
					</a>
					.
				</div>
			</div>
		</div>
	);
}
